import { Moment } from "moment";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { DateRange as DateSelectorDateRange } from "../../../commonComponents/DateSelector/types";

/**
 * Format number with commas and 2 decimal places
 */
export const addCommasInPrices = (value: string | number): string => {
  return (parseFloat(String(value)) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export interface Item {
  id: string;
  item: string;
  totalRevenue: string | number;
  totalTimesSold: number;
  imageUrl?: string;
}

export interface DateRange {
  startDate: Moment;
  endDate: Moment;
}

export interface Merchant {
  id: string;
  name?: string;
  role?: string;
  [key: string]: any;
}

export interface Store {
  id: string;
  name?: string;
  [key: string]: any;
}

export interface User {
  id: string;
  role: "admin" | "merchant" | string;
  [key: string]: any;
}

export interface KeyMetricsFilter {
  totalRevenue: string;
  averageRevenue: string;
  bestCategoryByRevenue: string;
  bestCategoryByUnitsSold: number;
}

export interface ItemSalesApiResponse {
  data: {
    items: Item[];
  };
  message?: string;
  status?: number;
  success?: boolean;
}

export interface InfoTileProps {
  title: string;
  subTitle: string;
  icon: IconDefinition;
  merchant: Merchant | null;
  storeId: string;
}

export interface ItemsRankingGridProps {
  data: Item[];
  isLoading?: boolean;
}

export interface ItemSalesTableProps {
  data: Item[];
  sortConfig: {
    key: string;
    isAscending: boolean;
  };
  onSort: (key: string) => void;
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (limit: number) => void;
  isLoading?: boolean;
}

export interface ItemSalesChartProps {
  data: Item[] | null;
  chartType: ChartType;
  metricOption: MetricOption;
  selectedDateRange: DateRange;
  onDateRangeChange: (range: DateRange) => void;
  onDateSelect: (selection: DateSelectorDateRange) => void;
  onMetricChange: (option: MetricOption) => void;
  onChartTypeChange: (type: ChartType) => void;
  keyMetrics: KeyMetricsFilter;
  isLoading: boolean;
}

export type ChartType = "line" | "bar";
export type MetricOption = "totalRevenue" | "totalTimesSold";
export type SortKey = "item" | "totalTimesSold" | "totalRevenue";
